import { AlertCircle, Inbox, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FriendlyIllustration, type FriendlyIllustrationKind } from "@/components/ui/FriendlyIllustration";
import { Skeleton } from "@/components/ui/skeleton";

export function AdminMetricSkeletons({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="admin-panel p-5">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-4 h-8 w-20" />
          <Skeleton className="mt-3 h-3 w-32" />
        </div>
      ))}
    </div>
  );
}

export function AdminErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="admin-panel flex flex-col items-center px-6 py-12 text-center">
      <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-rose-50 text-rose-700 ring-1 ring-rose-100">
        <AlertCircle className="h-5 w-5" />
      </div>
      <h2 className="mt-4 text-base font-semibold text-slate-900">Δεν φορτώθηκαν τα δεδομένα</h2>
      <p className="mt-1 max-w-md text-sm leading-6 text-slate-500">{message}</p>
      {onRetry && (
        <Button variant="outline" className="mt-5 min-h-11" onClick={onRetry}>
          <RefreshCw className="mr-2 h-4 w-4" /> Επανάληψη
        </Button>
      )}
    </div>
  );
}

export function AdminEmptyState({ title, description, illustration }: { title: string; description: string; illustration?: FriendlyIllustrationKind }) {
  return (
    <div className="flex min-h-52 flex-col items-center justify-center px-6 py-10 text-center">
      {illustration ? (
        <FriendlyIllustration kind={illustration} className="h-28 w-auto max-w-[190px] drop-shadow-[0_12px_20px_rgba(14,116,190,0.12)] sm:h-32" />
      ) : (
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-500">
          <Inbox className="h-5 w-5" />
        </div>
      )}
      <h3 className={illustration ? "mt-2 text-sm font-semibold text-slate-900" : "mt-4 text-sm font-semibold text-slate-900"}>{title}</h3>
      <p className="mt-1 max-w-sm text-sm leading-6 text-slate-500">{description}</p>
    </div>
  );
}
